<script setup lang="ts">
interface Props {
  value?: string
  isSearching?: boolean
}

interface Emits {
  (e: 'input', value: string): void
}

const emit = defineEmits<Emits>()

const onInput = (event: Event): void => {
  const target = event.target as HTMLInputElement
  emit('input', target.value)
}

defineProps<Props>()
</script>

<template>
  <div class="input-group">
    <label class="searchbar w-100">
      <input
        :value="value"
        @input="onInput"
        type="text"
        class="form-control"
        placeholder="Search Brands (e.g. Netflix)"
        aria-label="Search brands"
        name="query"
      />
    </label>
  </div>
</template>
